import { prop } from '@gov-nx/core/types';
import { usePersistedStore } from '../constants';
import type { DataBoxSearchState } from './store.types';

const isInHistory = (array: string[], string: string) =>
	array.some((str) => str.toLowerCase() === string.toLowerCase());

const useStore = <T>(selector: (state: DataBoxSearchState) => T) =>
	usePersistedStore(
		(set) => ({
			searchHistory: [],

			dataBoxSearchReset: () => set({ searchHistory: [] }),
			setDataBoxSearchHistory: (databoxSearch: string) =>
				set((state: DataBoxSearchState) => ({
					searchHistory: isInHistory(state.searchHistory, databoxSearch)
						? state.searchHistory
						: [databoxSearch, ...state.searchHistory],
				})),
			deleteDataboxSearchHistory: (databoxSearch: string) =>
				set((state: DataBoxSearchState) => ({
					searchHistory: state.searchHistory.filter(
						(item) => item !== databoxSearch
					),
				})),
		}),
		'dataBoxSearch',
		selector
	);

export const useDataBoxSearchStore = <T extends keyof DataBoxSearchState>(
	property: T
): DataBoxSearchState[T] => useStore(prop(property));
